import React, { FC, useState } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useVrmMaintenanceRoDetailsModel } from "../vrmBillMaintenanceRoModel";
import { Description } from "@/components/YhBox/Description";
import { Button } from 'antd';

export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookForm, } = useVrmMaintenanceRoDetailsModel();
    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const goToRepairDetail = (code:string) => {
        replaceNav(
            selectedNavId,
            "11-5",
            {
              id: code, mode: "",
              parentInfo: {
                selectedNavId,
              }
            },
            true)
    }
    const orderStatu: IDescription[] = [
        {
            label: "维修退单号",
            value: detailLookForm.returnCode ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: detailLookForm.status ?? "暂无",
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "维修单号",
            value: detailLookForm.maintenanceCode ?? "暂无",
            color: DescriptionColorEnum.blue,
            status: true,
            onClick: () => goToRepairDetail(detailLookForm.maintenanceCode as string)
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}